module.exports = __webpack_public_path__ + "img/logo_asosiasi.68721228.png";